// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"551":"ac707d04","796":"6385c642","841":"f1f6213e"}[chunkId] + ".chunk.js";
};